import { render, staticRenderFns } from "./EditPostService.vue?vue&type=template&id=4685237e&"
import script from "./EditPostService.vue?vue&type=script&lang=js&"
export * from "./EditPostService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports